import { Moment } from 'moment';

export type Timestamp = {
  id: number;
  fk_date: Moment;
  start: number;
  end?: number;
  type: StampType;
  logout_on_leave?: boolean;
};

export type MinimalTimestamp = {
  employee: string;
  end: number;
  id: number;
  start: number;
  type: StampType;
};

export type MinimalDate = {
  date: Date;
  minimalTimestamps?: MinimalTimestamp[];
};

export interface EmployeeIdToMinimalTimestamp {
  [key: string]: MinimalTimestamp[];
}

export type FullWorkingInfos = {
  dates: TimestampDate[];
  employee: string;
  expected_time: number;
  is_time: number;
  pause_time: number;
  holiday_days: number;
  public_holiday_days: number;
  sick_days: number;
};

export type TimestampDate = {
  id: number;
  timestamps?: Timestamp[];
  date: Moment;
  employee: string;
  non_working_time: number;
  pause_time: number;
  working_time: number;
};

export enum StampType {
  WORK = 'W',
  PAUSE = 'P',
  INITIAL = '',
}

export type EmployeeName = {
  firstName: '';
  lastName: '';
};
